/*TODO: 
    Usaremos esta lista para formatear los alias de los puestos; 
    ya que desde el back solo vienen los alias, lo que puede ser algo confuso
    para los usuarios. Ademas usando esta lista temporalmente, nos ahorramos 
    dos useEffect que podrían ralentizar la experiencia.

    ESTO ES TEMPORAL, HASTA QUE ENCONTREMOS UNA MEJOR SOLUCIÓN
*/

export const positionsPlaceholder = [
    {
      value: "ADM_PERSONAL_TEL_NO_PSI",
      name: "Administrativa (con personal a cargo y aten. telefónica) S/Psicológico"
    },
    {
      value: "ADM_PERSONAL_TEL",
      name: "Administrativa (con personal a cargo y aten. telefónica)"
    },
    {
      value: "ADM_NO_PERSONAL_NO_PSI",
      name: "Administrativa (s/ personal a cargo) S/Psicológico"
    },
    {
      value: "ADM_NO_PERSONAL",
      name: "Administrativa (sin personal a cargo)"
    },
    {
      value: "ADM_BASIC_TASKS_NO_TEL",
      name: "Administrativa (tareas basicas s/aten. telefo)"
    },
    {
      value: "WORKER",
      name: "Albañil"
    },
    {
      value: "AUTOELEVADORISTA",
      name: "Autoelevadorista"
    },
    {
      value: "CADETE",
      name: "Cadete"
    },
    {
      value: "CADETE_MOTO",
      name: "Cadete en Moto"
    },
    {
      value: "CAJERO",
      name: "Cajero"
    },
    {
      value: "CALL_CENTER",
      name: "Call Center"
    },
    {
      value: "CARGA_Y_DESCARGAS",
      name: "Carga y Descargas"
    },
    {
      value: "CARGAS_PELIGROSAS_O_PESADAS",
      name: "Cargas peligrosas o pesadas"
    },
    {
      value: "CARNICEROS",
      name: "Carnicero"
    },
    {
      value: "CASEROS",
      name: "Casero"
    },
    {
      value: "CHOFERES",
      name: "Chófer"
    },
    {
      value: "CONSTRUCCION",
      name: "Construcción"
    },
    {
      value: "CONTROL_DE_TIEMPOS",
      name: "Control de tiempos"
    },
    {
      value: "DEPOSITO",
      name: "Depósito"
    },
    {
      value: "ELECTRICISTA",
      name: "Electricista"
    },
    {
      value: "EMPLEADA_DOMESTICA_CUIDADO_PERSONAS",
      name: "Empleada doméstica (con cuidado de niños o adultos)"
    },
    {
      value: "ENCARGADO_EDIFICO",
      name: "Encargado de edificio"
    },
    {
      value: "ENCARGADO_SUCURSALES",
      name: "Encargado de sucursales"
    },
    {
      value: "ENF_INST_QUIRURGICA",
      name: "Enfermera/Instrumentadora quirúrgica"
    },
    {
      value: "GATRO_PANADEROS",
      name: "Gastronómicos/Panaderos"
    },
    {
      value: "LIMPIEZA",
      name: "Limpieza"
    },
    {
      value: "MAESTRANZA",
      name: "Maestranza"
    },
    {
      value: "MAESTRANZA_ESTABLECIMIENTOS",
      name: "Maestranza (de establecimientos)"
    },
    {
      value: "MECANICO",
      name: "Mecánico"
    },
    {
      value: "OPERADORA_FERRO",
      name: "Operadora Ferroviaria"
    },
    {
      value: "OPERADORA_INGRESOS",
      name: "Operadora de Ingresos"
    },
    {
      value: "OPERARIO_FABRICA",
      name: "Operario de Fábrica"
    },
    {
      value: "OPERARIO_FABRICA_NO_PSICO",
      name: "Operario de Fábrica S/Psicológico"
    },
    {
      value: "OPERARIO_ALTURA_ESPACIOS_CONFINADOS",
      name: "Operario en altura o espacios confinados"
    },
    {
      value: "PEON_RURAL",
      name: "Peón rural"
    },
    {
      value: "PERSONAL_DE_ESCUELA",
      name: "Personal de escuela - Poteros - Docente"
    },
    {
      value: "PLAYEROS_ESTACIONAMIENTO",
      name: "Playeros (playa de estacionamiento)"
    },
    {
      value: "PLAYEROS_ESTACION_SERVICIOS",
      name: "Playeros estación de servicios"
    },
    {
      value: "REPOSITORES",
      name: "Repositores"
    },
    {
      value: "SECRETARIA_ADMINISTRATIVA",
      name: "Secretaria Administrativa"
    },
    {
      value: "SECRETARIA_TELEFONO",
      name: "Secretaria con Teléfono"
    },
    {
      value: "SOLDADOR",
      name: "Soldador"
    },
    {
      value: "TORRISTAS",
      name: "Torristas"
    },
    {
      value: "TRACTORISTAS",
      name: "Tractoristas"
    },
    {
      value: "VENDEDOR_CALLE",
      name: "Vendedor de calle"
    },
    {
      value: "VENDEDOR_SALON",
      name: "Vendedor de salón"
    },
    {
      value: "VENDEDOR_SALON_NO_PSICO",
      name: "Vendedor de salón S/Psicológico"
    },
    {
      value: "VIAJANTE",
      name: "Viajante"
    },
    {
      value: "VIGILANCIA",
      name: "Vigilancia"
    },
    {
      value: "OTROS",
      name: "Otros"
    }
  ]